import type React from 'react';
import { useCallback } from 'react';
import {
  GalleryButtonGroupButton,
  GalleryButtonGroupLayerOptions,
  galleryLayerOptionsStreetMap,
} from './GalleryButtonGroup.styles';

interface GalleryButtonGroupV2Props {
  isMobile: boolean;
  visible: string;
  numPhotos: number;
  onYieldSelectOption: (option: string) => void;
}

const GalleryButtonGroupV2 = ({ isMobile, visible, numPhotos, onYieldSelectOption }: GalleryButtonGroupV2Props) => {
  const isShowingGallery = visible !== 'gallery';
  const isShowingMap = isMobile && visible !== 'map';
  const isShowingStreet = (isMobile && visible === 'map') || (!isMobile && visible === 'gallery');

  const handleGalleryClick = useCallback(() => {
    onYieldSelectOption('gallery');
  }, [onYieldSelectOption]);

  const handleMapClick = useCallback(() => {
    onYieldSelectOption('map');
  }, [onYieldSelectOption]);

  const handleStreetClick = useCallback(() => {
    onYieldSelectOption('street');
  }, [onYieldSelectOption]);

  const handleClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  }, []);

  return (
    <div onClick={handleClick}>
      <GalleryButtonGroupLayerOptions
        className={visible === 'street' || visible === 'map' ? galleryLayerOptionsStreetMap : ''}
      >
        {isMobile && isShowingGallery && (
          <GalleryButtonGroupButton onClick={handleGalleryClick}>See all {numPhotos} photos</GalleryButtonGroupButton>
        )}
        {isShowingMap && <GalleryButtonGroupButton onClick={handleMapClick}>Map</GalleryButtonGroupButton>}
        {isShowingStreet && (
          <GalleryButtonGroupButton onClick={handleStreetClick}>Street view</GalleryButtonGroupButton>
        )}
        {!isMobile && isShowingGallery && (
          <GalleryButtonGroupButton onClick={handleGalleryClick}>See all {numPhotos} photos</GalleryButtonGroupButton>
        )}
      </GalleryButtonGroupLayerOptions>
    </div>
  );
};

export default GalleryButtonGroupV2;
